import React, { Suspense } from 'react';
import Grid from '@material-ui/core/Grid';
import { ConfiguratorStore } from './Configurator.Store';
import { ConfiguratorForm } from './ConfiguratorForm';
import { autorun } from 'mobx';
import { configOptionKeys } from '../../../cli/src/config-generator';
var LazyConfiguratorResult = React.lazy(function () {
    return import('./ConfiguratorResult' /* webpackChunkName: 'ConfiguratorResult' */).then(function (_a) {
        var ConfiguratorResult = _a.ConfiguratorResult;
        return ({
            default: ConfiguratorResult,
        });
    });
});
// Get initial state from LocalStorage
function getInitialState() {
    try {
        var initial_1 = JSON.parse(localStorage.getItem('configOptions') || '{}');
        var result_1 = {};
        configOptionKeys.forEach(function (key) {
            result_1[key] = initial_1[key] === true;
        });
        return initial_1;
    }
    catch (_a) {
        return {};
    }
}
var configuratorStore = new ConfiguratorStore(getInitialState());
// Update LocalStorage on change
autorun(function () {
    var result = {};
    configOptionKeys.forEach(function (key) {
        result[key] = configuratorStore[key];
    });
    try {
        localStorage.setItem('configOptions', JSON.stringify(result));
    }
    catch (_a) { }
});
export var Configurator = function () { return (React.createElement("div", { style: { width: '100%', display: 'flex' } },
    React.createElement(Grid, { container: true, spacing: 24 },
        React.createElement(Grid, { item: true, xs: "auto", sm: 3 }),
        React.createElement(Grid, { item: true, xs: 12, sm: 9 },
            React.createElement(ConfiguratorForm, { store: configuratorStore })),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Suspense, { fallback: '' },
                React.createElement(LazyConfiguratorResult, { store: configuratorStore })))))); };
